module.exports = __webpack_public_path__ + "img/password.2a76df99.svg";